module.exports = __webpack_public_path__ + "static/8-312f291fa90e384d83e1a82c0fe884eb.mp4";